import type { BackgroundImage } from '../types/background-image.ts'

export const backgroundImageMap: Record<BackgroundImage, string> = {
  videographer: 'bg-videographer',
  'working-women': 'bg-working-women',
}
